/* NINEPADEL product pages: gallery, quantity, variant picker (generic + pack cards),
   price/stock/free-delivery updates, delivery timeline, kit builders, sticky bar.
   Shared by templates product (racket) and product.basic. Needs np-core.js (window.NP). */
(function(){
  'use strict';
  var NP = window.NP = window.NP || {};
  function $(s, r){ return (r || document).querySelector(s); }
  function $$(s, r){ return [].slice.call((r || document).querySelectorAll(s)); }
  function money(c){ return NP.formatMoney ? NP.formatMoney(c) : '£' + (c / 100).toFixed(2); }
  function money2(c){ return (NP.sym || '£') + (c / 100).toFixed(2); }
  function freeCents(){ return NP.freeShip || 10000; }

  /* ---------- delivery days (Today / Today / Tomorrow timeline) ---------- */
  var DAYS = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
  function nextWork(d){ var x = new Date(d); do { x.setDate(x.getDate() + 1); } while (x.getDay() === 0 || x.getDay() === 6); return x; }
  function same(a, b){ return a.toDateString() === b.toDateString(); }
  function paintDays(){
    var now = new Date(), cut = new Date(now); cut.setHours(NP.cutoffHour || 14, 0, 0, 0);
    var open = now.getDay() > 0 && now.getDay() < 6 && now < cut;
    var ship = open ? now : nextWork(now), arrive = nextWork(ship);
    var tom = new Date(now); tom.setDate(tom.getDate() + 1);
    function lab(d){ return same(d, now) ? 'Today' : same(d, tom) ? 'Tomorrow' : DAYS[d.getDay()] + ' ' + d.getDate(); }
    $$('[data-np-tl="ship"]').forEach(function(e){ e.textContent = lab(ship); });
    $$('[data-np-tl="arrive"]').forEach(function(e){ e.textContent = lab(arrive); });
    $$('[data-np-tl="mbar"]').forEach(function(e){ e.textContent = 'Delivery ' + (same(arrive, tom) ? 'tomorrow' : lab(arrive)); });
  }

  /* ---------- gallery thumbs ---------- */
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-np-thumb]'); if (!b) return;
    var gal = b.closest('[data-np-gal]'); if (!gal) return;
    showImage(gal, b.dataset.src, b.dataset.srcset);
    $$('[data-np-thumb]', gal).forEach(function(x){ x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
    var x8 = $('[data-np-x8]', gal); if (x8) x8.hidden = true;
  });
  function showImage(gal, src, srcset){
    var img = $('[data-np-main] img', gal); if (!img || !src) return;
    img.removeAttribute('srcset');
    if (srcset) img.setAttribute('srcset', srcset);
    img.src = src;
  }

  /* ---------- product root ---------- */
  function Pdp(root){
    var json = $('script[data-np-json]', root); if (!json) return;
    var data; try { data = JSON.parse(json.textContent); } catch (err) { return; }
    this.root = root; this.data = data; this.qty = 1;
    this.form = $('form[data-np-add]', root);
    var cur = +root.dataset.variant;
    this.variant = data.variants.filter(function(v){ return v.id === cur; })[0] || data.variants[0];
    this.bind(); this.update(false);
  }
  Pdp.prototype.bind = function(){
    var self = this, root = this.root;
    root.addEventListener('click', function(e){
      var q = e.target.closest('[data-np-q]');
      if (q){ self.qty = Math.max(1, Math.min(99, self.qty + (+q.dataset.npQ))); self.update(false); return; }
      var o = e.target.closest('[data-np-opt]');
      if (o && !o.disabled){ self.pick(+o.dataset.npOpt, o.dataset.value); }
    });
    var atc = $('[data-np-atc]', root), bar = $('[data-np-sticky]', root);
    if (atc && bar && 'IntersectionObserver' in window){
      new IntersectionObserver(function(en){
        bar.classList.toggle('on', !en[0].isIntersecting && en[0].boundingClientRect.top < 0);
      }).observe(atc);
    }
  };
  Pdp.prototype.pick = function(pos, value){
    var sel = this.variant.options.slice(); sel[pos - 1] = value;
    var vs = this.data.variants;
    var match = vs.filter(function(v){ return v.options.every(function(o, i){ return o === sel[i]; }); })[0];
    if (!match){
      var withVal = vs.filter(function(v){ return v.options[pos - 1] === value; });
      match = withVal.filter(function(v){ return v.available; })[0] || withVal[0];
    }
    if (!match) return;
    this.variant = match; this.update(true);
  };
  Pdp.prototype.update = function(changedVariant){
    var v = this.variant, root = this.root, q = this.qty, total = v.price * q, self = this;
    var idIn = $('input[name="id"]', this.form); if (idIn) idIn.value = v.id;
    var qIn = $('input[name="quantity"]', this.form); if (qIn) qIn.value = q;
    $$('[data-np-qty] output', root).forEach(function(o){ o.value = q; o.textContent = q; });
    var totalMode = root.dataset.priceMode === 'total';
    $$('[data-np-price]', root).forEach(function(e){ e.textContent = money(totalMode ? total : v.price); });
    $$('[data-np-compare]', root).forEach(function(e){
      var on = v.compare > v.price; e.hidden = !on;
      if (on) e.textContent = money(totalMode ? v.compare * q : v.compare);
    });
    $$('[data-np-klarna]', root).forEach(function(e){ e.textContent = money2(Math.floor(total / 3)); });
    $$('[data-np-stock]', root).forEach(function(e){ e.textContent = v.available ? (e.dataset.in || 'In stock') : (e.dataset.out || 'Sold out'); });
    var pre = root.dataset.preorder === '1';
    $$('[data-np-atc]', root).forEach(function(b){
      b.disabled = !v.available;
      b.textContent = v.available ? (pre ? 'Pre-order · ' : 'Add to basket · ') + money(total) : 'Sold out';
      b.dataset.label = b.textContent;
    });
    $$('[data-np-atc2]', root).forEach(function(b){ b.disabled = !v.available; b.textContent = v.available ? (pre ? 'Pre-order' : 'Add to basket') : 'Sold out'; });
    /* pack cards + per-ball line */
    var packBtn = $('[data-np-opt][data-balls][aria-pressed="true"]', root);
    $$('[data-np-opt]', root).forEach(function(b){
      var pos = +b.dataset.npOpt, on = v.options[pos - 1] === b.dataset.value;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (on && b.dataset.balls) packBtn = b;
      /* availability for this value combined with the other selected options */
      var sel = v.options.slice(); sel[pos - 1] = b.dataset.value;
      var ok = self.data.variants.some(function(x){ return x.available && x.options.every(function(o, i){ return o === sel[i]; }); });
      b.classList.toggle('out', !ok);
      if (b.hasAttribute('data-np-disable-out')) b.disabled = !ok;
    });
    $$('[data-np-opt-label]', root).forEach(function(e){ e.textContent = v.options[+e.dataset.npOptLabel - 1] || ''; });
    var per = $('[data-np-perline]', root);
    if (per && packBtn){
      var balls = +packBtn.dataset.balls, tubes = +packBtn.dataset.tubes;
      per.textContent = money2(Math.round(v.price / balls)) + ' a ball · ' + balls + ' balls' + (tubes > 1 ? ' in ' + tubes + ' tubes' : '');
    }
    var x8 = $('[data-np-x8]', root);
    if (x8){
      var box = packBtn && packBtn.dataset.box === 'true';
      x8.hidden = !box;
      if (box) x8.innerHTML = '×' + packBtn.dataset.tubes + '<small>TUBES IN A BOX</small>';
    }
    /* free next-day nudge */
    $$('[data-np-free]', root).forEach(function(p){
      var left = freeCents() - total, ok = left <= 0, span = $('span', p), use = $('use', p);
      p.classList.toggle('ok', ok);
      if (span) span.textContent = ok ? 'This qualifies for free next-day delivery.' : 'Add ' + money2(left) + ' more for free next-day delivery.';
      if (use) use.setAttribute('href', ok ? '#i-check' : '#i-truck');
    });
    $$('[data-np-sticky-line]', root).forEach(function(e){
      var t = money(total);
      if (!v.available) t = 'Sold out';
      else if (v.options.length && v.title !== 'Default Title') t = v.title + ' · ' + t;
      else if (total >= freeCents()) t += ' · free next-day';
      e.textContent = t;
    });
    if (changedVariant){
      var gal = $('[data-np-gal]', root);
      if (gal && v.img){
        showImage(gal, v.img, v.srcset);
        $$('[data-np-thumb]', gal).forEach(function(x){ x.setAttribute('aria-pressed', x.dataset.mid == v.mid ? 'true' : 'false'); });
      } else if (gal){
        /* no variant image: use the first image whose alt text or file name mentions an option value (e.g. "white") */
        var vals = v.options.map(function(o){ return String(o).toLowerCase(); }).filter(function(o){ return o.length > 2; });
        var hit = $$('[data-np-thumb]', gal).filter(function(x){
          var k = x.dataset.key || '';
          return vals.some(function(o){ return new RegExp('(^|[^a-z])' + o.replace(/[^a-z0-9]+/g, '[^a-z0-9]*') + '([^a-z]|$)').test(k); });
        })[0];
        if (hit){
          showImage(gal, hit.dataset.src, hit.dataset.srcset);
          $$('[data-np-thumb]', gal).forEach(function(x){ x.setAttribute('aria-pressed', x === hit ? 'true' : 'false'); });
        }
      }
      try {
        var url = new URL(location.href); url.searchParams.set('variant', v.id);
        history.replaceState(history.state, '', url.toString());
      } catch (err) {}
    }
    document.dispatchEvent(new CustomEvent('np:pdp:variant', { detail: { variant: v, qty: q, product: this.data.id } }));
  };

  /* ---------- racket kit builder: checkboxes inside its own add form ---------- */
  function Kit(root){
    var self = this; this.root = root; this.base = +root.dataset.base || 0;
    root.addEventListener('change', function(){ self.paint(); });
    document.addEventListener('np:pdp:variant', function(e){
      if (+root.dataset.product !== e.detail.product) return;
      self.base = e.detail.variant.price;
      var id = $('input[name="id"]', root); if (id) id.value = e.detail.variant.id;
      var sb = $('[type=submit]', root); if (sb) sb.disabled = !e.detail.variant.available;
      self.paint();
    });
    this.paint();
  }
  Kit.prototype.paint = function(){
    var r = this.root, sum = 0, c = 0;
    $$('input[data-np-extra]:checked', r).forEach(function(i){ sum += +i.dataset.price; c++; });
    var tot = this.base + sum, free = freeCents();
    var set = function(s, t){ var e = $(s, r); if (e) e.textContent = t; };
    set('[data-kit-base]', money2(this.base));
    set('[data-kit-add]', money2(sum));
    set('[data-kit-count]', c);
    set('[data-kit-total]', money2(tot));
    var bar = $('[data-kit-bar]', r); if (bar) bar.style.width = Math.min(100, tot / free * 100) + '%';
    var msg = $('[data-kit-msg]', r);
    if (msg) msg.innerHTML = tot >= free ? '<b>Free next-day delivery unlocked.</b>' : 'Add <b>' + money2(free - tot) + '</b> more for free next-day delivery.';
    var btn = $('[type=submit]', r);
    if (btn && btn.disabled){ btn.textContent = 'Sold out'; }
    else if (btn){ var noun = r.dataset.noun || 'racket'; btn.textContent = c ? 'Add ' + noun + ' + ' + c + ' to basket' : 'Add ' + noun + ' to basket'; btn.dataset.label = btn.textContent; }
  };

  /* ---------- basic full kit: toggle buttons + add all via NP.addItems ---------- */
  function FullKit(root){
    var self = this; this.root = root; this.base = +root.dataset.base || 0; this.main = +root.dataset.mainId || 0;
    root.addEventListener('click', function(e){
      var b = e.target.closest('[data-np-kit-item]');
      if (b){ var on = b.getAttribute('aria-pressed') !== 'true'; b.setAttribute('aria-pressed', on ? 'true' : 'false'); self.paint(); return; }
      var all = e.target.closest('[data-np-kit-all]');
      if (all) self.addAll(all);
    });
    document.addEventListener('np:pdp:variant', function(e){
      if (+root.dataset.product !== e.detail.product) return;
      self.base = e.detail.variant.available ? e.detail.variant.price : 0;
      self.main = e.detail.variant.available ? e.detail.variant.id : 0;
      self.paint();
    });
    this.paint();
  }
  FullKit.prototype.picked = function(){ return $$('[data-np-kit-item][aria-pressed="true"]', this.root); };
  FullKit.prototype.paint = function(){
    var p = this.picked(), tot = this.base;
    $$('[data-np-kit-item]', this.root).forEach(function(b){
      var on = b.getAttribute('aria-pressed') === 'true';
      b.innerHTML = '<svg class="i sm" aria-hidden="true"><use href="#i-' + (on ? 'check' : 'plus') + '"/></svg>' + (on ? 'Added' : 'Add');
    });
    p.forEach(function(b){ tot += +b.dataset.price; });
    var s = $('[data-np-kit-sum]', this.root);
    if (s) s.innerHTML = (this.root.dataset.noun || 'This') + ' + ' + p.length + ' item' + (p.length === 1 ? '' : 's') + ' · <b>' + money(tot) + '</b>';
  };
  FullKit.prototype.addAll = function(btn){
    var items = [];
    if (this.main) items.push({ id: this.main, quantity: 1 });
    this.picked().forEach(function(b){ items.push({ id: +b.dataset.variant, quantity: 1 }); });
    if (!items.length || !NP.addItems) return;
    var label = btn.innerHTML; btn.disabled = true; btn.textContent = 'Adding…';
    NP.addItems(items).then(function(){ NP.openCart && NP.openCart(); })
      .catch(function(err){ if(!(err && err.silent)) alert((err && (err.description || err.message)) || 'Sorry, that could not be added.'); })
      .finally(function(){ btn.disabled = false; btn.innerHTML = label; });
  };

  function init(){
    $$('[data-np-pdp]').forEach(function(r){ if (!r.npPdp) r.npPdp = new Pdp(r); });
    $$('[data-np-kit]').forEach(function(r){ if (!r.npKit) r.npKit = new Kit(r); });
    $$('[data-np-fullkit]').forEach(function(r){ if (!r.npKit) r.npKit = new FullKit(r); });
    paintDays();
  }
  function start(){ init(); setInterval(paintDays, 60000); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', init);
})();

/* Sticky gallery: if the gallery (main image + thumbnails) is taller than the
   window, pin it lower so its bottom row of thumbnails is never cut off. */
(function(){
  var HEAD = 88, GAP = 16;
  function fit(){
    document.querySelectorAll('.np-m .mgal-in').forEach(function(el){
      var main = el.querySelector('.mmain'), th = el.querySelector('.mthumbs');
      el.style.top = ''; if (main) { main.style.width = ''; main.style.justifySelf = ''; }
      if (th) { th.style.width = ''; th.style.justifySelf = ''; }
      if (getComputedStyle(el).position !== 'sticky') return;
      var avail = window.innerHeight - HEAD - GAP;
      // shrink the main image (down to 440px) so image + thumbnails fit the window
      for (var i = 0; i < 3 && main && el.offsetHeight > avail; i++) {
        var w = Math.max(440, Math.floor(main.getBoundingClientRect().width * avail / el.offsetHeight));
        main.style.width = w + 'px'; main.style.justifySelf = 'center';
        if (th) { th.style.width = w + 'px'; th.style.justifySelf = 'center'; }
      }
      // still too tall (short screens): pin lower so the thumbnails stay visible
      el.style.top = Math.min(HEAD, window.innerHeight - el.offsetHeight - GAP) + 'px';
    });
  }
  var q; function soon(){ cancelAnimationFrame(q); q = requestAnimationFrame(fit); }
  function start(){
    fit();
    window.addEventListener('resize', soon);
    window.addEventListener('load', soon);
    if (window.ResizeObserver) document.querySelectorAll('.np-m .mgal-in').forEach(function(el){ new ResizeObserver(soon).observe(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
